import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseDraggableWidget } from '../Card';
import { getAsset, getEventsByAsset, getTickets } from '../../../api';
import useAsync from '../../../hooks/useAsync';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { BaseList } from '../../Widgets/WidgetBase';
import {
	pluralize,
	classNames,
	getUserFullName,
} from '../../helpers/functions';
import useModal from '../../../hooks/useModal';
import SettingsContext from '../../../context/SettingsContext';
import { handleWidgetUpdateSettings } from '../helpers';

const dateKey = {
	SKIPPED: 'estimatedDate',
	ESTIMATED: 'estimatedDate',
	SCHEDULED: 'scheduledDate',
	COMPLETED: 'completedDate',
	RENEW: 'date',
};

const colorVariants = {
	critical: 'border-l-4 border-red-200',
	major: 'border-l-4 border-orange-200',
	minor: 'border-l-4 border-yellow-200/80',
};

const TITLE = 'Open Tickets';
const DESCRIPTION = 'Enter description here';
const CATEGORY = 'Blank Category';

const AssetOpenTickets = ({ title, isPreview, ...rest }) => {
	const { id } = useParams();

	const { setOpen: openTicketModal } = useModal('ticketOverview');

	const navigate = useNavigate();

	const {
		value: assetTickets,
		status: isLoadingTickets,
		error: hasError,
		execute: onRefreshTickets,
	} = useAsync(getTickets, {
		immediate: false,
	});

	const {
		settings,
		loading: isLoadingSettings,
		update: updateSettings,
	} = useContext(SettingsContext);

	const hasSettings = settings?.user?.widgetSettings
		? settings?.user?.widgetSettings[rest?.ctx?.data?.id]?.ticketStatus
		: null;

	const [selectedOption, setSelectedOption] = useState(
		hasSettings || 'inprogress'
	);

	useEffect(() => {
		onRefreshTickets(
			{ status: selectedOption?.split(','), assetId: id },
			null,
			{
				silent: true,
			}
		);
	}, [selectedOption]);

	if (isPreview) {
		return (
			<BaseDraggableWidget
				title={TITLE}
				category={CATEGORY}
				description={DESCRIPTION}
				{...rest}
				isPreview={true}
			/>
		);
	}

	const isEmpty =
		assetTickets?.rows?.length === 0
			? { isEmpty: true, flexCenter: true, skipIcon: true }
			: {};
	const isError = !!hasError ? { isError: true, flexCenter: true } : {};

	return (
		<BaseDraggableWidget
			title={TITLE}
			widgetProps={{
				isLoading: isLoadingTickets === 'pending',
				...isError,
				...isEmpty,
				isEmptyMessage: 'No open tickets',
				additonalMenuItems: [
					{
						name: 'Open new ticket',
						onClick: () => navigate(`/tickets/create?assetId=${id}`),
					},
				],
				options: [
					{ label: 'All', value: 'incoming,inprogress' },
					{ label: 'Incoming', value: 'incoming' },
					{ label: 'In Progress', value: 'inprogress' },
				],
				optionSelected: selectedOption,
				optionsOnChange: (index, value, raw) => {
					setSelectedOption(raw?.value);
					updateSettings(
						handleWidgetUpdateSettings(
							'ticketStatus',
							raw?.value,
							settings,
							rest?.ctx?.data?.id
						)
					);
				},
			}}
			{...rest}
		>
			<div>
				{assetTickets?.rows?.length
					? assetTickets?.rows
							?.sort(
								(a, b) =>
									new Date(a[dateKey[a.status]]) -
									new Date(b[dateKey[b.status]])
							)
							?.map((ticket) => {
								return (
									<div
										className={classNames(
											'py-2 cursor-pointer border-l-4 pl-6 ',
											ticket?.status !== 'done' && ticket?.status !== 'closed'
												? colorVariants[ticket?.severity]
												: ''
										)}
										onClick={() => openTicketModal({ id: ticket?.id })}
									>
										<div>
											<span className="font-semibold">
												{ticket?.ticketCode}
											</span>
											{` ${ticket?.subject}`}
										</div>

										<div className="text-gray-400 text-xxs">
											{`Opened ${moment(ticket?.createdAt).fromNow()}`}
											{`${
												ticket?.createdBy
													? ` by ${getUserFullName(ticket?.createdBy)}`
													: ''
											}`}
										</div>
									</div>
								);
							})
					: []}
			</div>
		</BaseDraggableWidget>
	);
};

export default AssetOpenTickets;
